var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgVisa = function SvgVisa(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_54_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6856 0.25H2.24334C1.14205 0.25 0.249268 1.14543 0.249268 2.25V13.75C0.249268 14.8546 1.14205 15.75 2.24334 15.75H21.6856C22.7869 15.75 23.6797 14.8546 23.6797 13.75V2.25C23.6797 1.14543 22.7869 0.25 21.6856 0.25Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77951 5.91444C2.25792 5.62751 1.66263 5.39674 0.99707 5.23659L1.02499 5.11188H3.75386C4.12374 5.12489 4.42388 5.23651 4.52155 5.63071L5.1146 8.46659L5.29628 9.32073L6.95733 5.11188H8.75082L6.08484 11.2775H4.29125L2.77951 5.91444ZM10.0701 11.2841H8.37398L9.43485 5.11188H11.1309L10.0701 11.2841ZM16.2186 5.26277L15.988 6.59559L15.8346 6.53004C15.5276 6.40525 15.1225 6.28054 14.5711 6.29371C13.9015 6.29371 13.6012 6.56277 13.5942 6.82546C13.5942 7.11441 13.9575 7.30484 14.5507 7.58725C15.5279 8.02719 15.9812 8.56557 15.9744 9.26819C15.9607 10.5486 14.8021 11.3761 13.0224 11.3761C12.2615 11.3694 11.5286 11.2181 11.1308 11.0476L11.3681 9.66205L11.5915 9.76066C12.1429 9.99071 12.5057 10.089 13.1829 10.089C13.6712 10.089 14.1947 9.89838 14.2014 9.48488C14.2014 9.21565 13.9784 9.01851 13.3222 8.71646C12.6802 8.42087 11.8218 7.92848 11.8357 7.04198C11.8429 5.84042 13.0224 5 14.6974 5C15.3535 5 15.8841 5.13789 16.2186 5.26277ZM18.4729 9.09749H19.8827C19.8129 8.78889 19.4918 7.31147 19.4918 7.31147L19.3732 6.77964C19.2895 7.00943 19.143 7.38373 19.1501 7.37056C19.1501 7.37056 18.6126 8.7429 18.4729 9.09749ZM20.5665 5.11188L21.9349 11.284H20.3644C20.3644 11.284 20.2108 10.5748 20.1621 10.3581H17.9844C17.9214 10.5222 17.6284 11.284 17.6284 11.284H15.8487L18.3681 5.62399C18.5427 5.22342 18.85 5.11188 19.2546 5.11188H20.5665Z",
    fill: "#171E6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_54_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9289,
    height: 16,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Visa.13512ec27f00419c6f3db30809db9d4a.svg";